import { CommonSimpleBar } from 'components/CommonSimpleBar';
import styles from './index.module.scss';

/**
 * SelectAreaコンポーネントに渡されるプロパティを定義するインターフェース
 */
interface Props {
  /** エリアのタイトル */
  title: string;
  /** 子要素 */
  children: React.ReactNode;
}

/**
 * SelectAreaは指定されたエリア内にコンテンツを表示するコンポーネント
 *
 * @param {Props} props - コンポーネントに渡されるプロパティ
 * @returns {JSX.Element} - 指定されたエリア内にコンテンツを表示する要素
 */
export const SelectArea: React.FC<Props> = ({ title, children }) => {
  return (
    <div>
      <h3 className={styles.occupationModalSelectArea__title}>{title}</h3>
      <div
        className={styles.occupationModalSelectArea__scrollarea}
        style={{ maxHeight: 308 }}
      >
        <CommonSimpleBar>{children}</CommonSimpleBar>
      </div>
    </div>
  );
};
